/* Native disclosure and form remain usable without JavaScript. */
if (!customElements.get('adepsia-header-language')) {
  customElements.define('adepsia-header-language', class extends HTMLElement {
    constructor() {
      super();
      this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this);
      this.closeOnEscape = this.closeOnEscape.bind(this);
      this.closeOnFocusLeave = this.closeOnFocusLeave.bind(this);
    }

    connectedCallback() {
      this.disclosure = this.querySelector('details');
      this.toggle = this.querySelector('summary');
      document.addEventListener('click', this.closeOnOutsideClick);
      this.addEventListener('keydown', this.closeOnEscape);
      this.addEventListener('focusout', this.closeOnFocusLeave);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.closeOnOutsideClick);
      this.removeEventListener('keydown', this.closeOnEscape);
      this.removeEventListener('focusout', this.closeOnFocusLeave);
    }

    closeOnOutsideClick(event) {
      if (!this.contains(event.target)) this.disclosure.open = false;
    }

    closeOnEscape(event) {
      if (event.key !== 'Escape' || !this.disclosure.open) return;
      event.stopPropagation();
      this.disclosure.open = false;
      this.toggle.focus();
    }

    closeOnFocusLeave(event) {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) {
        this.disclosure.open = false;
      }
    }
  });
}
